import React, { memo, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import config from '../../App/config';
import PersonalInfo from './stepForms/personalInfo';
import AccountInfo from './stepForms/accountInfo';
import { ACCOUNT_INFO, PHONE_NUMBER_VERIFICATION, STEP_NAMES, STEP_TITLES } from './constants';
import { useGuidedRegContext } from '../context/guidedRegContext';
import StepIndicatorTabs from '../../global/atoms/stepIndicatorTabs/StepIndicatorTabs';
import NumberVerification from './joinCashAccount/verify';
import { addFormReloadWarning } from '../utils/guidedUtil';
import { STORAGE_CONFIG } from '../../../constants/storageConfig';
import { CREATE_ACCOUNT_PATH } from '../constants';
import { ENV_CONFIG } from '../../../constants/envConfig';
import './stepForms/stepforms.scss';

const CashFlow = () => {
    const [{ currentStepIndex, formData }] = useGuidedRegContext();
    const basePath = config.pagePaths.cashWorkflow;
    const { CASH_WORKFLOW_DATA_PREVIEW_MODE: isPreviewMode } = ENV_CONFIG || {};

    useEffect(() => {
        //check submissionId exist
        const submissionId = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.CCA_SUBMISSION_ID);
        const isAuthoredURL = window.location.href.startsWith('https://author-');
        if (!(isAuthoredURL || isPreviewMode == 'true') && !submissionId) {
            // navigate to gr flow
            window.location.href = window?.location?.protocol + '//' + window?.location?.host + CREATE_ACCOUNT_PATH;
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (currentStepIndex > 0 || formData[STEP_NAMES[0]]?.data?.firstName !== '') {
            const customEvent = new Event('event');
            window.dispatchEvent(customEvent);
            const cleanup = addFormReloadWarning(true);
            return () => {
                cleanup;
            };
        }
    }, [currentStepIndex]);

    return (
        <>
            {location.pathname.includes(PHONE_NUMBER_VERIFICATION) ? (
                ''
            ) : (
                <div>
                    <StepIndicatorTabs stepTitles={STEP_TITLES} currentStep={currentStepIndex} />
                </div>
            )}

            {
                <Routes>
                    <Route path={basePath} element={<PersonalInfo />} />
                    <Route path={`${basePath}${ACCOUNT_INFO}`} element={<AccountInfo />} />
                    <Route path={`${basePath}${PHONE_NUMBER_VERIFICATION}`} element={<NumberVerification />} />
                </Routes>
            }
        </>
    );
};

export default memo(CashFlow);
